import { callCallableNativeSafe } from "./callableNativeSafe";

export function bookingPaymentCallable(functionName) {
  return (data) => callCallableNativeSafe({
    functionName, data, requireAuth: true, requireAppCheck: true, timeoutMs: 60000,
  });
}
